exports.urlImage = (img) => {
  return `https://online-foods.herokuapp.com/images/${img}`;
};
